/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Login_TitleInputs */

const he_seo_login_title = /** @type {(inputs: Seo_Login_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחברות - Pricedrop`)
};

const en_seo_login_title = /** @type {(inputs: Seo_Login_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign In - Pricedrop`)
};

/**
* | output |
* | --- |
* | "Sign In - Pricedrop" |
*
* @param {Seo_Login_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const seo_login_title = /** @type {((inputs?: Seo_Login_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Login_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_login_title(inputs)
	return en_seo_login_title(inputs)
});